// src/services/authService.js
import { getUserByUsername } from './userService'; // Import the user service function

// --- SIMULATION ---
// In a real app, these users might come from an API or a more secure source.
// Roles: 'admin', 'manager', 'staff', 'accountant'
const mockUsers = {
    admin: { id: 1, username: 'admin', password: 'password', role: 'admin', name: 'Admin User' },
    manager: { id: 2, username: 'manager', password: 'password', role: 'manager', name: 'Manager User' },
    staff: { id: 3, username: 'staff', password: 'password', role: 'staff', name: 'Staff User' },
    accountant: { id: 4, username: 'accountant', password: 'password', role: 'accountant', name: 'Accountant User' },
  };
  
  const USER_STORAGE_KEY = 'loan_servicing_user';
  
  export const login = async (username, password) => {
    console.log("[authService] Attempting login for:", username);
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 300));
  
    // *** Fetch user from userService ***
    const user = await getUserByUsername(username);
    console.log("[authService] User found by service:", user);
  
    // Check if user exists, is active, and password matches (DEMO check)
    if (user && user.password === password && user.isActive) { // Check isActive flag
      console.log("[authService] Password match SUCCESS!");
      // *** IMPORTANT: Store only NON-SENSITIVE data ***
      // Exclude password before storing in localStorage
      const { password: userPassword, ...userDataToStore } = user;
      localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userDataToStore));
      return userDataToStore; // Return user data without password
    }
  
    // --- Failure Logging ---
    if (!user) { console.log("[authService] Login FAILED: User not found or inactive."); }
    else if (user.password !== password) { console.log("[authService] Login FAILED: Password mismatch."); }
    else { console.log("[authService] Login FAILED: Unknown reason."); }
    // ----------------------
  
    localStorage.removeItem(USER_STORAGE_KEY); // Clear on failed attempt
    return null; // Return null on failure
  };
  export const logout = () => {
    localStorage.removeItem(USER_STORAGE_KEY);
  };
  
  export const getStoredUser = () => {
    const storedUser = localStorage.getItem(USER_STORAGE_KEY);
    try {
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Error parsing stored user:", error);
      localStorage.removeItem(USER_STORAGE_KEY); // Clear corrupted data
      return null;
    }
  };
  // --- END SIMULATION ---